<template>
  <div class="list-full">
    <div id="info" class="editing">
      <h1>
        <input type="text" v-model="list.title" @change="update()" />
      </h1>

      <div v-if="isMine" id="list-status">
        <input type="checkbox" v-model="list.is_published" @change="update()" />
        <label for="is_published">Published</label>

        <input type="checkbox" v-model="list.is_private" @change="update()" />
        <label for="is_published">Private</label>

        <p class="done">
          <router-link :to="{ name: 'ListView', params: { id: list.id }}">done</router-link>
        </p>
      </div>
    </div>

    <div id="search" v-if="isMine">
      <input id="search-field" type="text" placeholder="search for an album" @input="searchAlbums" v-model="searchQuery" />

      <div class="suggestions">
        <div class="album" v-for="sugg in suggestions" v-bind:key="sugg.id">
          <div><img :src="sugg.image" width="50" height="50" /></div>
          <div>
            <span class="title">{{ sugg.name }}</span>
            <br/>
            <span class="artist">{{ sugg.artist }}</span>
          </div>
          <div class="controls">
            <button @click="addAlbum(sugg.id)">Add to list</button>
          </div>
        </div>
      </div>
    </div>

    <div id="list-contents">
      <div class="album" v-for="entry in list.entries" v-bind:key="entry.id">
        <img width="80px" height="80px" :src="entry.album.thumbnail" />
        <h2>
          <span class="title">{{ entry.album.title }}</span>
          <span class="artist">{{ entry.album.artist.name }}</span>
        </h2>
        <div class="controls">
          <button v-if="isMine" @click="removeAlbum(entry.id)">Remove</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ListsService from '@/services/ListsService'
import AlbumsService from '@/services/AlbumsService'
export default {
  name: 'list',
  data () {
    return {
      list: {entries: []},
      suggestions: [],
      searchQuery: '',
      isMine: false
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  mounted () {
    this.getList()
    // this.getAlbumSuggestions()
  },
  methods: {
    getList () {
      ListsService.fetchList(this.$route.params.id)
        .then((response) => {
          this.list = response.data
          document.title = `${this.list.title} - an album list by ${this.list.user.username} - Long Player`
          this.isMine = this.$parent.user && (this.list.user.id === this.$parent.user.id)
        })
        .catch(() => {
          this.$router.push({ name: 'Home' })
        })
    },
    async getAlbumSuggestions () {
      const response = await AlbumsService.suggestAlbums()
      this.suggestions = response.data
    },
    searchAlbums () {
      if (this.searchQuery.length < 3) {
        this.suggestions = []
        return
      }

      AlbumsService.searchAlbums(this.searchQuery)
        .then((response) => {
          console.log(response)
          this.suggestions = response.data.data
        })
    },
    addAlbum (spotifyId) {
      ListsService.addEntry(this.list.id, spotifyId)
        .then(() => {
          this.getList()
          this.searchQuery = ''
          this.suggestions = []
          document.getElementById('search-field').focus()
        })
    },
    removeAlbum (entryId) {
      ListsService.removeEntry(this.list.id, entryId)
        .then(() => {
          this.getList()
        })
    },
    update () {
      ListsService.update(
        this.list.id,
        this.list.title,
        this.list.is_published,
        this.list.is_private
      )
        .then(() => {
        })
        .catch(() => {
          //
        })
    },
    publishList (isPublished) {
      ListsService.publish(this.list.id, isPublished)
        .then(() => {
          this.list.is_published = isPublished
        })
        .catch(() => {
          //
        })
    }
  }
}
</script>
<style type="text/css">
  #info.editing h1 input {
    font-size: 1.2em;
    background: transparent;
    width: 100%;
    color: #444;
    border: 2px solid #444;
  }

  .list-full .album h2 {
    padding-left: 10px;
  }
  .list-full .album .controls {
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditList.vue